import { render, staticRenderFns } from "./OneSurveyEdit.vue?vue&type=template&id=37094454&scoped=true&"
import script from "./OneSurveyEdit.vue?vue&type=script&lang=js&"
export * from "./OneSurveyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37094454",
  null
  
)

export default component.exports